import './index.scss';

import React from 'react'
import Link from 'gatsby-link'

const Menu = ({ latestExp }) => (
  <ul className="home__menu">
    <li>
      <Link to='/experiments'>
        <h1>Experiments</h1>
      </Link>
      <h4 style={{ marginTop: '10px' }}>latest: <strong style={{ letterSpacing: '1px' }}>
        <Link to={latestExp.fields.slug}>
        {latestExp.frontmatter.title}</Link>
        </strong>
      </h4>
    </li>
    <li>
      <Link to='/work'>
        <h1>Work & Experience</h1>
      </Link>
    </li>
    <li>
      <Link to='/projects'>
        <h1>Projects</h1>
      </Link>
    </li>
    <li>
      <Link to='/about'>
        <h1>About Me</h1>
      </Link>
    </li>
  </ul>
);

const ContactForm = () => (
  <div className="contact" id="contact">
    <h1>Contact</h1>
    <div className="container">
      <div style={{maxWidth: '525px', margin: '50px auto 50px auto', textAlign: 'center'}}>
        <p>{"Yes. I'm available for freelance data viz and website design/dev work!"}</p>
      </div>
      <form action="https://formspree.io/andrewlomaxr@gmail.com"
        method="POST">
        <div className="input">
          <label htmlFor="name">Name</label>
          <input type="text" name="name" />
        </div>
        <div className="input">
          <label htmlFor="_replyto">Email</label>
          <input type="email" name="_replyto" />
        </div>
        <div className="input">
          <label htmlFor="message">Message</label>
          <textarea name="message" rows="6" />
        </div>
        <input type="submit" value="Send" />
      </form>
    </div>
  </div>
);

export default class Home extends React.Component {

  render(){
    let projects = this.props.data.allMarkdownRemark.edges;

    return (
      <div className="page home">
        <Menu latestExp={projects[0].node}/>
        <ContactForm />
      </div>
    );
  }
}

export const pageQuery = graphql`
  query HomepageExpQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { fileAbsolutePath: {regex : "\/experiments/"} }
    ){
      edges {
        node {
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            description
          }
          fields {
            slug
          }
        }
      }
    }
  }`



// WEBPACK FOOTER //
// ./src/pages/index.js